class WaitOpFinish {
    execute(callback) {
        /*
         * Implementations should execute the callback and return
         * a promise that resolves when the operation finishes.
         */
        throw new Error("Method .execute is not implemented");
    }
}

export default WaitOpFinish;
